
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/[subdomain]/accreditation/[id]",
      function () {
        return require("private-next-pages/page/[subdomain]/accreditation/[id].tsx");
      }
    ]);
  